import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-new-editor',
  templateUrl: './index.html',
  styleUrls: ['./index.scss'],
})
export class NewEditorComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() template: any;
  @Input() variables: any;
  @Input() title: string;
  @Output() EditorStateChanged = new EventEmitter();
  @ViewChild('editorIframe') iframe: ElementRef | undefined;
  currentUser: any = {};

  iframeSrc = '';
  editorUrl = '';

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
    const queryParams = new URLSearchParams({
      visualEditorId: this.template.visualEditorId,
      accessToken: this.currentUser.token,
      campaignId: this.template.campaignId,
      influencerTypeId: this.template.influencerTypeId,
      templateId: this.template.templateId,
      templateTypeId: this.template.templateTypeId,
      pageTitle: this.title,
      topPanel: 'false',
    }).toString();
    this.editorUrl = `${environment.apiUrl}/api/v1/editor/?${queryParams}`;
    window.addEventListener('message', this.handleEditorMessages.bind(this));
  }

  ngAfterViewInit(): void {
    if (this.iframe) {
      this.iframeSrc = `${this.editorUrl}&topPanel=false`;
      this.iframe.nativeElement.src = this.iframeSrc;

      this.iframe.nativeElement.onload = () => {
        if (!!this.template) {
          console.log('ngAfterViewInit', {
            action: 'init-data',
            origin: 'visualEditor',
            pageTitle: this.title,
            templateBody: this.template.body,
            templateJsonBody: this.template.bodyJson,
            variables: this.variables.influencer,
            visualEditorId: this.template.visualEditorId,
            accessToken: this.currentUser.token,
            campaignId: this.template.campaignId,
            influencerTypeId: this.template.influencerTypeId,
            templateId: this.template.templateId,
            templateTypeId: this.template.templateTypeId,
          });
          this.iframe.nativeElement.contentWindow.postMessage(
            {
              action: 'init-data',
              origin: 'visualEditor',
              pageTitle: this.title,
              templateBody: this.template.body,
              templateJsonBody: this.template.bodyJson,
              visualEditorId: this.template.visualEditorId,
              variables: this.variables.influencer,
              accessToken: this.currentUser.token,
              campaignId: this.template.campaignId,
              influencerTypeId: this.template.influencerTypeId,
              templateId: this.template.templateId,
              templateTypeId: this.template.templateTypeId,
            },
            '*'
          );
        } else {
          this.iframe.nativeElement.contentWindow.postMessage(
            {
              action: 'init-data',
              origin: 'visualEditor',
              pageTitle: this.title,
              templateBody: null,
              templateJsonBody: null,
              visualEditorId: null,
              variables: this.variables.influencer,
              accessToken: this.currentUser.token,
              campaignId: null,
              influencerTypeId: null,
              templateId: null,
              templateTypeId: null,
            },
            '*'
          );
        }
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['template'] && this.template && this.iframe) {
      this.iframe.nativeElement.src = this.iframeSrc;
    }
  }

  handleEditorMessages(event: MessageEvent): void {
    console.log('handleEditorMessages', event);
    if (event.data.origin === 'visualEditor') {
      if (event.data.action === 'save') {
        this.EditorStateChanged.emit({
          body: event.data.body,
          bodyJson: event.data.body_json,
          visualEditorId: event.data.visualEditorId,
          action: 'save',
        });
      }

      if (event.data.action === 'close') {
        this.EditorStateChanged.emit({
          action: 'close',
        });
      }
    }
  }
}
